import { createContext } from "react";
import { initial_toast } from "./reducer";
import { ToastContext as ToastContextType } from "./types";

const ToastContext = createContext<ToastContextType>({ toast: initial_toast, dispatch: () => null})
export default ToastContext
